import React from 'react'

export default function Snoozer({item, onDurationClick}) {

	function handleClick(duration) {
		onDurationClick(item, duration)
	}

	// ISO 8601 Durations > https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
	return (
		<div
			className="snoozeUntil"
			onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
		>
			<button onClick={handleClick.bind(this,"PT4H")}>4 hours</button>
			<button onClick={handleClick.bind(this,"P1D")}>1 day</button>
			<button onClick={handleClick.bind(this,"P3D")}>3 days</button>
			<button onClick={handleClick.bind(this,"P1W")}>1 week</button>
			<button onClick={handleClick.bind(this,"P2W")}>2 weeks</button>
			<button onClick={handleClick.bind(this,"P1M")}>1 month</button>
			<button onClick={handleClick.bind(this,"P3M")}>3 months</button>
			<button onClick={handleClick.bind(this,"onhold")}>Pause</button>
			<button onClick={handleClick.bind(this,"active")}>Activate</button>
		</div>
	);
};
// <button onClick={handleClick.bind(this,"PT2M")}>2 minutes</button>


// WEBPACK FOOTER //
// ./src/widgets/snoozer.jsx